import React from "react";
import { useState, useEffect } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Form, Formik } from "formik";
import { useTheme } from '@mui/material/styles';
import {
  MyTextArea,
  MyTextInput,
} from "../services/authentication/inputServices";
import { Store } from "react-notifications-component";
import Loader from "../components/Helpper/Loader";
import {
  getAllUplodedImage,
  deleteUploadedimage,
} from "../services/web/webServices";

function UploadedImage() {
  const theme = useTheme();
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const [getLoader, setLoader] = useState(true);
  const [showEye, setShowEye] = useState(false);
  const [uploadesImagesdata, setUploadedImagesData] = useState([]);
  const [getButton, setButton] = useState(true);
  const [uploadedImage, setUploadedImage] = useState([]);
  const [select, setSelection] = useState([]);
  const OpenSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };
  const pageName = "Uploaded Images";

  const handleClose1 = () => setShowEye(false);
  const handleShow1 = (params) => {
    setUploadedImagesData(params);
    setShowEye(true);
  };

  useEffect(() => {
    setLoader(true);
    getAllUplodedImage()
      .then((res) => {
        const data = Array.isArray(res?.data?.data) ? res.data.data : [];
        setUploadedImage(
          data.map((el, index) => ({
            ...el,
            id: el.id,
            i: index,
          }))
        );

        setLoader(false);
      })

      .catch((err) => {
        setLoader(false);
        console.log(err);
      });
  }, []);

  const columns = [
    {
      field: "sno",
      headerName: "S.NO.",
      filterable: false,
      renderCell: (index) => `${index.row.i + 1}`,
      width: 100,
    },

    {
      field: "fullname",
      headerName: "Name",
      width: 200,
      renderCell: (params) => {
        const { userId } = params.row;
        const firstName = userId ? userId.firstName : "N/A";
        const lastName = userId ? userId.lastName : "";

        return <div>{userId ? `${firstName} ${lastName}` : "N/A"}</div>;
      },
    },

    {
      field: "email",
      headerName: "Email",
      width: 250,
      renderCell: (params) => {
        return <div>{params.row.userId ? params.row.userId.email : "N/A"}</div>;
      },
    },
    {
      field: "place",
      headerName: "Place",
      width: 220,
      renderCell: (params) => {
        return (
          <div>{params.row.placeId ? params.row.placeId.title : "N/A"}</div>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 110,
      renderCell: (params) => {
        return (
          <>
            <Button
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
              onClick={() => handleShow1(params)}
            >
              <i className="fas fa-eye"></i>
            </Button>

            <Button
              color="error"
              onClick={onDelete(params)}
              style={{
                backgroundColor: "#64A433",
                border: "none",
                marginRight: "5px",
              }}
            >
              <i className="fa fa-trash" aria-hidden="true"></i>
            </Button>
          </>
        );
      },
    },
  ];

  const css = `
  .form-container {
  display: flex;
  gap: 10px; /* Adjust the spacing between input fields */
  margin-bottom: 15px; /* Adjust margin if needed */
}

.form-group {
  flex: 1; /* Makes form-group divs flexible */
}



.form-control {
  width: 100%; /* Ensures input fields take full width of their container */
}
   label {
  color: #555659; 
}
 .form-label {
  margin-bottom: 5px;
  display: block;
  font-weight: bold;
}
 
}
`;

  const onDelete = (params) => () => {
    if (window.confirm("Are you sure you want to delete?")) {
      deleteUploadedimage(params.row.id)
        .then((res) => {
          Store.addNotification({
            title: "Success",
            message: res?.data?.message,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true,
            },
          });
          setLoader(true);
          getAllUplodedImage()
            .then((res) => {
              const data = Array.isArray(res?.data?.data) ? res.data.data : [];
              setUploadedImage(
                data.map((el, index) => ({
                  ...el,
                  id: el.id,
                  i: index,
                }))
              );

              setLoader(false);
            })

            .catch((err) => {
              setLoader(false);
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  return (
    <>
      <style>{css}</style>
      <div className="grid-container">
        <Sidebar
          openSidebarToggle={openSidebarToggle}
          OpenSidebar={OpenSidebar}
        />
        <Header OpenSidebar={OpenSidebar} pageName={pageName} />
        <div
          style={{
            gridArea: "main",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            // margin: "0 150px 150px",
            margin: "0 90px 150px",
          }}
        >
          <Box
            sx={{ height: 500, width: "100%", boxShadow: 7, marginTop: "85px" }}
          >
            {getLoader ? (
              <Loader />
            ) : uploadedImage.length > 0 ? (
              <>
                <DataGrid
                  rows={uploadedImage}
                  columns={columns}
                  initialState={{
                    pagination: {
                      paginationModel: { page: 0, pageSize: 10 },
                    },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                  disableRowSelectionOnClick
                  onSelectionChange={(newSelection) => {
                    setSelection(newSelection.rows);
                  }}
                  sx={{
                    "& .MuiDataGrid-row:nth-of-type(odd)": {
                      backgroundColor: theme.palette.action.hover, // Light grey background
                    },
                    "& .MuiDataGrid-cell:last-child": {
                      border: 0, // Hide the last cell border
                    },
                  }}
                />
              </>
            ) : (
              <p style={{ fontSize: "30px", padding: "30px" }}>
                No data found.
              </p>
            )}
          </Box>
          <Modal show={showEye} onHide={handleClose1} size="lg">
            <Modal.Header closeButton>
              <Modal.Title>Uploaded Images Detail</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Formik
                initialValues={{
                  email: uploadesImagesdata?.row?.userId
                    ? uploadesImagesdata?.row?.userId?.email
                    : "",
                  name: uploadesImagesdata?.row?.userId
                    ? `${uploadesImagesdata.row.userId.firstName} ${uploadesImagesdata.row.userId.lastName}`
                    : "",
                  place: uploadesImagesdata?.row?.placeId
                    ? uploadesImagesdata?.row?.placeId?.title
                    : "",
                }}
              >
                {(props) => (
                  <Form>
                    <div className="form-container">
                      <div className="form-group">
                        <label className="form-label">Name:</label>
                        <MyTextInput
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          readOnly
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">Email:</label>
                        <MyTextInput
                          type="email"
                          id="email"
                          name="email"
                          className="form-control"
                          readOnly
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="form-label">Place:</label>
                      <MyTextInput
                        type="text"
                        id="place"
                        name="place"
                        className="form-control"
                        readOnly
                      />
                    </div>
                    <div className="form-container">
                      <div>
                        <div
                          className="form-group"
                          style={{
                            height: "300px",
                            width: "500px",
                            marginTop: "10px",
                          }}
                        >
                          <label className="form-label">Uploaded Image:</label>
                          {uploadesImagesdata?.row?.image ? (
                            <div>
                              <img
                                src={uploadesImagesdata?.row?.image}
                                style={{ width: "200px", height: "280px" }}
                                alt="Uploaded"
                              />
                              <div
                                style={{
                                  position: "absolute",
                                  marginLeft: "230px",
                                  marginTop: "-150px",
                                }}
                              >
                                <a
                                  href={uploadesImagesdata?.row?.image}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    marginRight: "10px",
                                    padding: "5px 10px",
                                    backgroundColor: "#007bff",
                                    color: "#fff",
                                    textDecoration: "none",
                                    borderRadius: "4px",
                                  }}
                                >
                                  View Image
                                </a>
                              </div>
                            </div>
                          ) : (
                            <span>No Uploaded Image Found!</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose1}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default UploadedImage;
